import React, { PropTypes } from 'react';

import cx from "classnames";
import { Button, FormControl, FormGroup, InputGroup } from "react-bootstrap";
import PlaneIcon from '!url-loader!../../../../images/seek/plane.svg';

import { translations } from '../../../../i18n';
import styles from './input.module.scss';

interface SearchInputBarProps {
  className?: string;
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  disabled?: boolean;
  placeholder?: string | null;
}

export const SearchInputBar: React.FC<SearchInputBarProps> = ({ className, value, placeholder, disabled, onChange, onSubmit }) => {
  const inputRef = React.useRef<HTMLInputElement>(null);
  const placeholders = translations.translation["seek.placeholders"] || [];

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  }

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSubmit();
  }

  return (
    <div className={cx(styles.container, className)}>
      <form onSubmit={handleSubmit}>
        <div className={styles.inner}>
          <input type='text' ref={inputRef} value={value} onChange={handleChange} placeholder={placeholder || ""} disabled={disabled} />
          {!placeholder &&
            <div className={styles.placeholder} onClick={() => {
              inputRef.current?.focus();
            }}>
              <div className={styles.wrapper}>
                {placeholders.map((text, index) => {
                  return <div key={index} className={styles.text}>{text}</div>
                })}
              </div>
            </div>
          }
          <button disabled={value == '' || disabled} type="submit" className={styles.submitButton}>
            <img src={`${process.env.IMAGE_CDN_URL}/images/seek/plane.svg`} />
          </button>
        </div>
      </form>
    </div>
  );
}